import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectPerms } from '../../fragments/generated/ProjectPerms';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectPermissionsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectPermissionsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, permissions?: { __typename?: 'ProjectPermissions', canEditTranscription: boolean, canCopyComment: boolean, canDownloadComment: boolean, canDelete: boolean, canUpdate: boolean, canUpdateAsset: boolean, canCreateAsset: boolean, canShare: boolean, canCreateComment: boolean, canUpdateCommentStatus: boolean, canReactToComment: boolean, canViewComment: boolean, canCreateCommentAttachment: boolean, canDeleteComment: boolean, canDownloadCommentAttachment: boolean, canCopyAsset: boolean, canDeleteAsset: boolean, canMoveAsset: boolean, canDownloadAsset: boolean, canDeleteCollection: boolean, canUpdateCollection: boolean, canCreateCollection: boolean, canManageAssetMetadata: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canViewTranscription: boolean, canCreateTranscription: boolean, canDeleteTranscription: boolean, canDownloadTranscription: boolean, canCreateCaption: boolean, canDeleteCaption: boolean, canDownloadCaption: boolean, canViewCaption: boolean, canUpdateCaption: boolean } | null } | null } | null };


export const GetProjectPermissions = /*#__PURE__*/ gql`
    query GetProjectPermissions($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      ...ProjectPerms
    }
  }
}
    ${ProjectPerms}` as unknown as DocumentNode<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>;

          

          export const useGetProjectPermissionsQuery = (options?:QueryHookOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>) => useQuery(GetProjectPermissions, options);

          

          export type GetProjectPermissionsQueryOptions = QueryHookOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>;

          

          export const useGetProjectPermissionsLazyQuery = (options?:LazyQueryHookOptions<GetProjectPermissionsQuery, GetProjectPermissionsQueryVariables>) => useLazyQuery(GetProjectPermissions, options);

          

          export type GetProjectPermissionsQueryResult = ReturnType<typeof useGetProjectPermissionsQuery>;

          
